import { useEffect, useRef, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import toast, { Toaster } from 'react-hot-toast';
import "../../../dashboard/styles.css";
import { Link, useNavigate } from 'react-router-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getToken } from "../../../../utils/auth";
import axios from "axios";
import { MdCheckBoxOutlineBlank, MdOutlineDone } from "react-icons/md";
import { FaSquareCheck } from "react-icons/fa6";
import { Autocomplete, Checkbox, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'

import { TiMessages } from "react-icons/ti";
import { MdMailOutline } from "react-icons/md";
import { MdOutlineWhatsapp } from "react-icons/md";
import { GoUpload } from "react-icons/go";
import { TbPlayerPauseFilled } from "react-icons/tb";
import { AiFillAudio } from "react-icons/ai";
import pdf from '../../../../assets/images/pdf.png'
import { ReactMic } from 'react-mic';
import { IoClose } from "react-icons/io5";
import RecordRTC from 'recordrtc';
import { t } from "i18next";


const QrcDetails = ({ category, condition, advice, emergencyContact, handleGetQrc, qrcId, desPage, setDesPage, handleGetAdvice }) => {
    const navigate = useNavigate();
    const conditions = condition?.map((i) => i?._id)

    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);

    const [formData, setFormData] = useState({
        "emergencyContactIds": [],
        "categoryId": null,
        "conditionIds": [],
        "adviceId": null,

    });
    const [communicationChannel, setCommunicationChannel] = useState({
        // "communicationChannel": {
        "enableEmail": false,
        "enableWhatsapp": false,
        "enableSMS": false,
        "enableVoiceMessage": false
        // }

    });
    const [qrcDetails, setQrcDetails] = useState(null)
    const [moreAdvice, setMoreAdvice] = useState(null)
    const [adviceUploadedFiles, setAdviceUploadedFiles] = useState([]);
    const [previewUrl, setPreviewUrl] = useState([]);
    const [adviceText, setAdviceText] = useState(null);
    const [adviceFile, setAdviceFile] = useState(null);
    const [start, setStart] = useState(null);
    const [audioState, setAudioState] = useState(null);
    const [recording, setRecording] = useState(false);
    const [blob, setBlob] = useState(null);
    const [audioLoader, setAudioLoader] = useState(null);
    const [fileLoader, setFileLoader] = useState(null);
    const [recordedBlob, setRecordedBlob] = useState(null);
    const recordRTC = useRef(null);

    const startRecording = () => {
        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
            .then((stream) => {
                recordRTC.current = RecordRTC(stream, { type: 'audio' });
                recordRTC.current.startRecording();
                setRecording(true);
            })
            .catch((err) => console.error('Error accessing media devices.', err));
    };

    const stopRecording = () => {
        recordRTC.current.stopRecording(() => {
            const blob = recordRTC.current.getBlob();
            setRecordedBlob(blob);
            setRecording(false);
        });
    };

    const splitFileLink = (a) => {
        const x = a.split('_');
        const y = x[x.length - 1];
        return decodeURIComponent(y);
    }

    // const startRecording = () => {
    //     setRecording(true);
    // };

    // const stopRecording = () => {
    //     setRecording(false);
    // };

    // const onStop = (recordedBlob) => {
    //     setBlob(recordedBlob.blob);
    //     // handleAudioFileUpload();
    // };

    const handleMultiSelect = (key, newValue) => {
        setFormData((prevData) => ({
            ...prevData,
            [key]: newValue,
        }));

    }
    const handleDropdownChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    };
    useEffect(() => {
        if (qrcId) {
            handleGetQrcDetails();
        }
    }, [qrcId])
    useEffect(() => {
        if (qrcDetails?.qrcContentId?.conditionIds?.length > 0) {

            setCommunicationChannel({
                "enableEmail": qrcDetails?.qrcContentId?.communicationChannel?.enableEmail,
                "enableWhatsapp": qrcDetails?.qrcContentId?.communicationChannel?.enableWhatsapp,
                "enableSMS": qrcDetails?.qrcContentId?.communicationChannel?.enableSMS,
                "enableVoiceMessage": qrcDetails?.qrcContentId?.communicationChannel?.enableVoiceMessage
            })

            let b = [];
            for (let i = 0; i < qrcDetails?.qrcContentId?.conditionIds?.length; i++) {
                let a = condition.find((j) => j?._id === qrcDetails?.qrcContentId?.conditionIds[i]?._id)
                if (a) {
                    b.push(a)
                }

            }
            let x = [];
            for (let i = 0; i < qrcDetails?.qrcContentId?.emergencyContactIds?.length; i++) {
                let y = emergencyContact.find((j) => j?._id === qrcDetails?.qrcContentId?.emergencyContactIds[i]?._id)
                if (y) {
                    x.push(y)
                }
            }
            setFormData({
                "emergencyContactIds": x,
                "categoryId": qrcDetails?.qrcContentId?.categoryId?._id,
                "conditionIds": b,
                "adviceId": qrcDetails?.qrcContentId?.adviceId?._id,
            })
        }
        else {
            setFormData({
                "emergencyContactIds": [],
                "categoryId": null,
                "conditionIds": [],
                "adviceId": null,
            })
            setCommunicationChannel({
                "enableEmail": false,
                "enableWhatsapp": false,
                "enableSMS": false,
                "enableVoiceMessage": false
            })
        }

    }, [qrcDetails])
    const handleUpdateQrc = async (e) => {
        e.preventDefault();
        if (formData?.categoryId === null || formData?.categoryId === 'Select Category') {
            toast.error('Category required!');
            return;
        }

        try {
            let condId = formData?.conditionIds?.map((i) => i?._id);
            let emergencyId = formData?.emergencyContactIds?.map((i) => i?._id);
            const dataToSent = {
                "emergencyContactIds": emergencyId,
                "categoryId": formData?.categoryId,
                "conditionIds": condId,
                "adviceId": formData?.adviceId,
                'communicationChannel': communicationChannel
            }
            const token = getToken();
            const response = await axios.put(
                `${process.env.REACT_APP_URL}/api/qrc/${qrcId}`, dataToSent,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            toast.success(response?.data?.message);
            setDesPage(null);
            handleGetQrc();
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }
    const handleGetQrcDetails = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/qrc/${qrcId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            setQrcDetails(response?.data?.data);


        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }
    const handleAddAdvice = async (e) => {
        e.preventDefault();
        if (!adviceText) {
            toast.error('Please add advice');
            return;
        }
        try {

            const formData = {
                'adviceText': adviceText,
                'adviceDocuments': previewUrl,
                'adviceVoiceNoteLink': audioState,
            }

            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/advice`,
                formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );

            toast.success(response?.data?.message);
            setMoreAdvice(null);
            handleGetAdvice();
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }
    const MAX_IMAGES = 4;
    const handleAdviceFileUpload = async (event) => {
        const chosenFiles = Array.prototype.slice.call(event.target.files)
        const uploaded = [...adviceUploadedFiles];
        if (chosenFiles?.length > MAX_IMAGES) {
            toast.error(`You can only upload up to ${MAX_IMAGES} images.`);
            return;
        };
        chosenFiles.some((file) => {
            if (file?.size > 2097152) {
                toast.error('Entity is too large')
                return;
            };
            uploaded.push(file);
        })
        setAdviceUploadedFiles(uploaded);
        try {
            setFileLoader(true)
            const formData = new FormData();
            uploaded.forEach((file) => {
                formData.append('files', file)
            })
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
                formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            }
            );
            toast.success(response?.data?.message);
            setPreviewUrl(response?.data?.data);
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setFileLoader(false);
        }
    };
    const handleAudioFileUpload = async () => {
        try {
            setAudioLoader(true);
            const formData = new FormData();
            // uploaded.forEach((file) => {
            formData.append('voiceNote', recordedBlob, 'audio.wav')
            // })
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/voiceNote/upload`,
                formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            }
            );
            setRecordedBlob(null);
            toast.success(response?.data?.message)
            setAudioState(response?.data?.data);
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setAudioLoader(false);
        }
    };

    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<Modal size="md" className="fade margin-modal" id="qr-modal" onHide={() => setDesPage(null)} show={desPage} centered >
                <Modal.Header closeButton>
                    <Modal.Title>{t("qrcDetails")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <div className="rounded p-2 px-4 d-flex flex-column gap-3" >

                        <Form.Select onChange={handleDropdownChange}
                            style={{
                                borderRadius: '4px',
                                border: '1px solid #c7c7c7',
                                padding: '9px'
                            }}
                            // size='lg'
                            name="categoryId"
                            value={formData?.categoryId}
                            label={t("selectCategory")}>
                            <option>{t("selectCategory")}</option>
                            {
                                category?.map((i, index) =>
                                    <option value={i?._id}>{i?.categoryName}</option>
                                )
                            }
                        </Form.Select>
                        <Form.Select
                            style={{
                                borderRadius: '4px',
                                border: '1px solid #c7c7c7',
                                padding: '9px'
                            }}
                            label={t("selectAdvice")}
                            onChange={handleDropdownChange}
                            name="adviceId"
                            value={formData?.adviceId}>
                            <option>{t("selectAdvice")}</option>
                            {
                                advice?.map((i, index) =>
                                    <option value={i?._id}>{i?.adviceText}</option>
                                )
                            }
                        </Form.Select>

                        <Autocomplete
                            size='small'
                            disablePortal
                            multiple
                            disableCloseOnSelect
                            // limitTags={5}
                            displayEmpty
                            className='w-100'
                            id="combo-box-demo"
                            options={condition}
                            defaultValue={formData?.conditionIds}
                            value={formData?.conditionIds}
                            getOptionLabel={(option) => option?.conditionName}

                            sx={{
                                width: 300
                            }}
                            renderInput={(params) => <TextField {...params} label="Select condition" />}
                            onChange={(e, newValue) => {
                                handleMultiSelect('conditionIds', newValue)
                            }}
                            renderOption={(props, option, { selected }) => (
                                <li {...props} style={{ alignItems: 'center', padding: '8px 16px', whiteSpace: 'nowrap' }}>
                                    <Checkbox
                                        icon={<MdCheckBoxOutlineBlank />}
                                        checkedIcon={<FaSquareCheck />}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    <div>

                                        <div className=''>
                                            <span>{option?.conditionName}</span>
                                        </div>
                                    </div>
                                </li>
                            )}
                        />


                        <Autocomplete
                            size='small'
                            disablePortal
                            multiple
                            disableCloseOnSelect
                            className='add-vendor-autocomplete w-100'
                            id="combo-box-demo"
                            defaultValue={formData?.emergencyContactIds}
                            value={formData?.emergencyContactIds}
                            options={emergencyContact}
                            getOptionLabel={(option) => option?.firstName + ' ' + option?.lastName}

                            sx={{
                                width: 300
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Emergency Contact" />}
                            onChange={(e, newValue) => {
                                handleMultiSelect('emergencyContactIds', newValue)
                            }}

                            renderOption={(props, option, { selected }) => (
                                <li {...props} style={{ alignItems: 'center', padding: '8px 16px', whiteSpace: 'nowrap' }}>
                                    <Checkbox
                                        icon={<MdCheckBoxOutlineBlank />}
                                        checkedIcon={<FaSquareCheck />}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    <div>

                                        <div className=''>
                                            <span>{option?.firstName + ' ' + option?.lastName}</span>
                                        </div>
                                    </div>
                                </li>
                            )}
                        />
                        <label className="text-start" style={{ fontSize: "15px" }}>{t("communication_channel")}</label>
                        <div className='d-flex align-items-start justify-content-between'>
                            <div className='d-flex align-items-start gap-2'>
                                <Form.Check // prettier-ignore
                                    style={{ width: "15px" }}
                                    type="switch"
                                    id="custom-switch"
                                    checked={communicationChannel?.enableSMS}
                                    value={communicationChannel?.enableSMS}
                                    onChange={(e) => {
                                        setCommunicationChannel({ ...communicationChannel, ['enableSMS']: !communicationChannel?.enableSMS })
                                    }}
                                />
                                <div className='d-flex align-items-start gap-1'>
                                    <TiMessages className='text-primary' style={{ fontSize: "20px" }} />
                                    <label>{t("sms")}</label>
                                </div>
                            </div>
                            <div className='d-flex align-items-start gap-2'>
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    id="custom-switch-1"
                                    style={{ width: "15px" }}
                                    checked={communicationChannel?.enableEmail}
                                    value={communicationChannel?.enableEmail}
                                    onChange={(e) => {
                                        setCommunicationChannel({ ...communicationChannel, ['enableEmail']: !communicationChannel?.enableEmail })
                                    }}
                                />
                                <div className='d-flex align-items-start gap-1' >
                                    <MdMailOutline className='' style={{ fontSize: "20px", color: "#b33333" }} />
                                    <label >{t("mail")}</label>
                                </div>
                            </div>
                            <div className='d-flex align-items-start gap-2'>
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    id="custom-switch"
                                    style={{ width: "15px" }}
                                    checked={communicationChannel?.enableWhatsapp}
                                    value={communicationChannel?.enableWhatsapp}
                                    onChange={(e) => {
                                        setCommunicationChannel({ ...communicationChannel, ['enableWhatsapp']: !communicationChannel?.enableWhatsapp })
                                    }}
                                />
                                <div className='d-flex align-items-start gap-1'>
                                    <MdOutlineWhatsapp className='' style={{ fontSize: "20px", color: "#00d500" }} />
                                    <label>{t("whatsapp")}</label>
                                </div>
                            </div>
                        </div>

                        <Button type="submit" className="w-100" onClick={handleUpdateQrc}>{t("continue")}</Button>
                        <div>
                            <div className="text-primary text-start" style={{ cursor: "pointer" }} onClick={() => { setMoreAdvice(true) }}>{"+"}{t("addMoreAdvice")}</div>
                        </div>
                        {
                            moreAdvice &&
                            <div className="border rounded p-3">
                                <div className="text-end"><IoClose style={{ fontSize: "20px" }} onClick={() => setMoreAdvice(null)} /></div>
                                <div className="">
                                    <textarea
                                        className="form-control rounded "
                                        type="text"
                                        placeholder="Type the advice..."
                                        style={{ border: "none", borderBottom: "2px solid #cfcfcf" }}
                                        name="adviceText"
                                        value={adviceText}
                                        onChange={(e) => setAdviceText(e.target.value)}
                                    />
                                    <div className='d-flex gap-3 justify-content-between align-items-center w-100 mt-3 text-nowrap'>
                                        {
                                            recording ?
                                                <div className='w-50' onClick={stopRecording} ><TbPlayerPauseFilled fontSize={30} /></div>
                                                :
                                                <div className='w-50' onClick={startRecording} ><AiFillAudio fontSize={30} /></div>
                                        }
                                        <div className='w-100 bg-primary rounded text-white p-2 d-flex align-items-center justify-content-center gap-1 ' onClick={handleAudioFileUpload} type="button">  {audioLoader ? <span id="orderLoading"></span> : 'Save Audio'}</div>
                                        <div className='d-flex w-100 align-items-center justify-content-center '>
                                            <label
                                                htmlFor="file-input"
                                                style={{ cursor: "pointer" }}
                                                className='w-100'
                                            >

                                                <input
                                                    id="file-input"
                                                    type="file"
                                                    name="image"
                                                    accept="application/pdf"
                                                    multiple
                                                    style={{ display: "none" }}
                                                    onChange={handleAdviceFileUpload}
                                                />
                                                <div className=" bg-primary rounded text-white p-2 d-flex align-items-center justify-content-center gap-1 ">  {fileLoader ? <span id="orderLoading"></span> : 'upload Pdf'}  </div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex gap-3 ">
                                        {
                                            previewUrl?.map(doc =>
                                                <div className='d-flex flex-column'>
                                                    <Link to={`${doc}`} target="_blank" className='pointer text-dark d-flex flex-column' style={{ fontSize: "10px", textDecoration: "none" }}>
                                                        <img src={pdf} alt='documents' style={{
                                                            background: 'rgb(221 221 221)',
                                                            borderRadius: '20px',
                                                            padding: '10px',
                                                            width: '50px',
                                                            height: '50px',
                                                        }} />
                                                        {splitFileLink(doc)}<br />
                                                    </Link>
                                                </div>
                                            )
                                        }
                                    </div>

                                    <Button className="bg-warning rounded border-0 text-white mt-4 w-100" type="submit" onClick={(e) => handleAddAdvice(e)}>{t("add")} </Button>
                                    {/* </form> */}
                                </div>
                            </div>
                        }

                    </div>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default QrcDetails
